import { AxiosPromise } from 'axios';
import apiClient from 'apiClient';
import {
  CommissionsResponseData,
  CommissionTermsCreateResponse,
  CommissionTermsGetResponse,
  CommissionTermsPostPayload,
  CommissionTermsUpdatePayload,
  CommissionTermsUpdateResponse,
  ProductResponseData,
} from './types';

export const fetchSingleCommissionDetails = (id: string): AxiosPromise<CommissionTermsGetResponse> =>
  apiClient.get(`/api/v1/broker-management/commission-term/${id}`);

export const postCommissionDetails = (
  payload: CommissionTermsPostPayload,
): AxiosPromise<CommissionTermsCreateResponse> => apiClient.post('/api/v1/broker-management/commission-term/', payload);

export const updateCommissionDetails = (
  id: string,
  payload: CommissionTermsUpdatePayload,
  force = false,
): AxiosPromise<CommissionTermsUpdateResponse> =>
  apiClient.post(`/api/v1/broker-management/commission-term${force ? '-force' : ''}/${id}`, { ...payload, force });

export const fetchProductsData = (): AxiosPromise<ProductResponseData> =>
  apiClient.get('/api/v1/fma/commissioned-products');

export const fetchAllCommissions = (): AxiosPromise<CommissionsResponseData> =>
  apiClient.get('/api/v1/broker-management/commission-terms');
